import Link from "next/link";

import Layout from "../components/layouts/layout.comp";
import { useTranslation } from "../core/translation.core";
import membershipCore from "../core/membership.core";
import LocalePs from "../components/locale/localePs.core";
import { ListSection, Tag } from "../components/reuseables/list.comp";
import localeCore from "../core/locale.core";
import ErrorCenterIcon from "../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../icons/loadingOvalCenter.icon";
import { Membership } from "../types/membership";
import AddLink from "../components/form/addLink.comp";
import OutlineBtn from "../components/form/outlineBtn.comp";
import { toast } from "react-toastify";
import useMemberships from "../hooks/useMemberships.hook";

export default function MembershipsPage() {
  const { t, msg } = useTranslation();

  async function handleRunCron() {
    membershipCore
      .refreshShopMembership()
      .then((data) => toast.success("Success"))
      .catch((error) => toast.error("Something Went Wrong"));
  }

  return (
    <Layout
      title={t(msg.membership.membership)}
      titleBtn={<AddLink id="membership-create" href="/membership/create" />}
      // rightBtns={[
      //   <OutlineBtn id="run-autoissue-cron" key="run-autoissue-cron" onClick={handleRunCron}>
      //     Update Shop Memberships
      //   </OutlineBtn>,
      // ]}
    >
      <ListSection>
        <MembershipsList />
      </ListSection>
    </Layout>
  );
}

const MembershipsList = () => {
  const { t, msg } = useTranslation();
  const { data, isPending, isError, error } = useMemberships();

  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (isPending) return <LoadingOvalCenterIcon />;

  return (
    <div id="membership-list" className="pt-6 lg:pt-0">
      <div className="hidden lg:grid lg:grid-cols-[3fr_3fr_3fr_2fr_1fr_1fr] gap-6 px-6 py-3 text-sm font-medium">
        <div>{t(msg.general.name)}</div>
        <div>{t(msg.category.code)}</div>
        <div>{t(msg.membership.activationMethod)}</div>
        <div>{t(msg.membership.validityPeriod)}</div>
        <div>{t(msg.membership.defaultTier)}</div>
        <div></div>
      </div>

      {data!.map((a) => (
        <Row key={a.id} membership={a} />
      ))}
    </div>
  );
};

function Row({ membership }: { membership: Membership }) {
  const { t, msg } = useTranslation();

  return (
    <div className="membership-row grid grid-cols-2 lg:grid-cols-[3fr_3fr_3fr_2fr_1fr_1fr] gap-x-6 gap-y-3 px-6 py-6 border-t-[1px] text-sm group/edit" data-code={membership.code}>
      <div data-value={localeCore.getLocaleValueDefault(membership.name)}>
        <Tag>{t(msg.general.name)}</Tag>
        <LocalePs value={membership.name} />
      </div>
      <div data-value={localeCore.getLocaleValueDefault(membership.name)}>
        <Tag>{t(msg.category.code)}</Tag>
        <p>{membership.code}</p>
      </div>
      <div data-value={membership.issueMode}>
        <Tag>{t(msg.membership.activationMethod)}</Tag>
        <LabelIssueMode membership={membership} />
      </div>

      <div data-value={membership.validityPeriod}>
        <Tag>{t(msg.membership.validityPeriod)}</Tag>
        <p>
          {membership.validityPeriod} {t(msg.general.day)}
        </p>
      </div>
      <div data-value={membership.default ? "default" : ""}>
        <Tag>{t(msg.membership.defaultTier)}</Tag>
        {membership.default ? (
          <span className="inline-block rounded px-2 py-0.5 text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200">
            {t(msg.membership.defaultTierBadge)}
          </span>
        ) : (
          <p>—</p>
        )}
      </div>
      <div className="col-span-2 lg:col-span-1 opacity-0 group-hover/edit:opacity-100">
        <Link className="membership-edit underline" href={`/membership/edit/${membership.id}`}>
          {t(msg.form.edit)}
        </Link>
      </div>
    </div>
  );
}

function LabelIssueMode({ membership }: { membership: Membership }) {
  const { t, msg } = useTranslation();

  switch (membership.issueMode) {
    case "auto":
      return <p>{t(msg.product.auto)}</p>;
    case "manual":
      return <p>{t(msg.product.manual)}</p>;
    default:
      return null;
  }
}
